/**
 * SHOPIFY CART PAGE v2 — JavaScript
 * File: assets/cart-page.js
 * No jQuery. Vanilla ES6+. Defer-loaded.
 * ✅ Pack discount display on page load + AJAX update
 */
(function () {
  'use strict';

  const CONFIG = {
    currency: 'Rs.',
    debounce: 480,
    toastMs: 3200,
  };

  let _debTimer = null;

  /* ── Money ── */
  function money(cents) {
    return CONFIG.currency + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── Toast ── */
  function toast(msg, isErr) {
    let el = document.querySelector('.c-toast');
    if (!el) { el = document.createElement('div'); el.className = 'c-toast'; document.body.appendChild(el); }
    el.textContent = msg;
    el.style.background = isErr ? '#d44a2a' : '#0f0f0f';
    el.classList.add('show');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('show'), CONFIG.toastMs);
  }

  /* ══════════════════════════════════════════════════════
     PACK DISCOUNT HELPER
     Properties se discounted price calculate karo
  ══════════════════════════════════════════════════════ */
  function getDiscountedPrices(item) {
    const props      = item.properties || {};
    const discPct    = parseInt(props['_discount_pct']    || 0, 10);
    const origPrice  = parseInt(props['_original_price']  || 0, 10);
    const packQty    = parseInt(props['_pack_qty']        || 0, 10);

    if (discPct > 0 && origPrice > 0 && packQty > 0) {
      const rawTotal       = origPrice * packQty;
      const discountedLine = Math.round(rawTotal * (100 - discPct) / 100);
      const discountedUnit = Math.round(origPrice * (100 - discPct) / 100);
      return { linePrice: discountedLine, unitPrice: discountedUnit, hasDiscount: true };
    }

    return { linePrice: item.line_price, unitPrice: item.price, hasDiscount: false };
  }

  /* ══════════════════════════════════════════════════════
     PAGE LOAD — discount display
     cart-page.liquid mein data-* attributes se read karo
  ══════════════════════════════════════════════════════ */
  function applyDiscountOnLoad() {
    let grandTotal = 0;

    document.querySelectorAll('[data-key]').forEach(row => {
      const discPct   = parseInt(row.dataset.discountPct   || 0, 10);
      const origPrice = parseInt(row.dataset.originalPrice || 0, 10);
      const packQty   = parseInt(row.dataset.packQty       || 0, 10);

      const linePriceEl = row.querySelector('[data-line-price]');
      const priceSubEl  = row.querySelector('[data-price-sub]');

      if (discPct > 0 && origPrice > 0 && packQty > 0) {
        const rawTotal       = origPrice * packQty;
        const discountedLine = Math.round(rawTotal * (100 - discPct) / 100);
        const discountedUnit = Math.round(origPrice * (100 - discPct) / 100);

        grandTotal += discountedLine;

        if (linePriceEl) {
          /* Compare price dikhao agar discount hai */
          const existingCompare = linePriceEl.querySelector('.cp-compare-price');
          if (!existingCompare) {
            const compareEl = document.createElement('span');
            compareEl.className = 'cp-compare-price';
            compareEl.style.cssText = 'text-decoration:line-through;color:#9c9c98;font-size:12px;margin-right:6px;';
            compareEl.textContent = money(rawTotal);
            linePriceEl.insertAdjacentElement('beforebegin', compareEl);
          }
          linePriceEl.textContent = money(discountedLine);
          linePriceEl.style.color = 'var(--c-sale, #d44a2a)';
        }

        if (priceSubEl && packQty > 1) {
          priceSubEl.textContent = money(discountedUnit) + ' × ' + packQty;
          priceSubEl.style.display = '';
        }

        /* Saving badge inject karo */
        if (!row.querySelector('.cp-saving-badge')) {
          const saving = rawTotal - discountedLine;
          const badge  = document.createElement('div');
          badge.className = 'cp-saving-badge';
          badge.style.cssText = 'color:#ff348b;font-size:11px;font-weight:600;margin-top:4px;';
          badge.textContent = 'You save: ' + money(saving) + ' (' + discPct + '% OFF)';
          if (linePriceEl) linePriceEl.closest('.cart-item__price-block')?.appendChild(badge);
        }

      } else {
        /* Normal item — existing rendered price se parse karo */
        const rawText = linePriceEl ? linePriceEl.textContent.trim() : '0';
        const match   = rawText.match(/[\d,]+\.\d{1,2}/);
        const cents   = match ? Math.round(parseFloat(match[0].replace(/,/g, '')) * 100) : 0;
        grandTotal   += cents || 0;
      }
    });

    /* Subtotal + total update karo */
    document.querySelectorAll('[data-subtotal]').forEach(el => el.textContent = money(grandTotal));
    document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = money(grandTotal));
  }

  /* ══════════════════════════════════════════════════════
     AJAX UPDATE — applyCart
     Cart change ke baad DOM update karo
  ══════════════════════════════════════════════════════ */
  function applyCart(cart) {
    let grandTotal = 0;

    cart.items.forEach(item => {
      const row = document.querySelector(`[data-key="${item.key}"]`);
      if (!row) return;

      const { linePrice, unitPrice, hasDiscount } = getDiscountedPrices(item);
      grandTotal += linePrice;

      /* Line price */
      const linePriceEl = row.querySelector('[data-line-price]');
      if (linePriceEl) {
        linePriceEl.textContent = money(linePrice);
        if (hasDiscount) linePriceEl.style.color = 'var(--c-sale, #d44a2a)';
      }

      /* Unit × qty sub text */
      const priceSub = row.querySelector('[data-price-sub]');
      if (priceSub && item.quantity > 1) {
        priceSub.textContent = money(unitPrice) + ' × ' + item.quantity;
        priceSub.style.display = '';
      } else if (priceSub) {
        priceSub.style.display = 'none';
      }

      /* Saving badge update */
      if (hasDiscount) {
        const props     = item.properties || {};
        const discPct   = parseInt(props['_discount_pct']   || 0, 10);
        const origPrice = parseInt(props['_original_price'] || 0, 10);
        const packQty   = parseInt(props['_pack_qty']       || 0, 10);
        const rawTotal  = origPrice * packQty;
        const saving    = rawTotal - linePrice;

        let badge = row.querySelector('.cp-saving-badge');
        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'cp-saving-badge';
          badge.style.cssText = 'color:#ff348b;font-size:11px;font-weight:600;margin-top:4px;';
          linePriceEl?.closest('.cart-item__price-block')?.appendChild(badge);
        }
        badge.textContent = 'You save: ' + money(saving) + ' (' + discPct + '% OFF)';
      }

      /* Qty input sync */
      const input = row.querySelector('.qty-ctrl__val');
      if (input && document.activeElement !== input) input.value = item.quantity;
    });

    /* Subtotal / total */
    document.querySelectorAll('[data-subtotal]').forEach(el => el.textContent = money(grandTotal));
    document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = money(grandTotal));
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

    const meta = document.querySelector('.cart-heading__meta');
    if (meta) meta.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
  }

  /* ── AJAX update ── */
  async function updateQty(key, qty) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!r.ok) throw new Error();
      const cart = await r.json();
      applyCart(cart);

      if (qty === 0) {
        const row  = document.querySelector(`[data-key="${key}"]`);
        const name = row?.querySelector('.cart-item__name')?.textContent?.trim() || 'Item';
        if (row) {
          row.style.maxHeight = row.offsetHeight + 'px';
          requestAnimationFrame(() => { row.classList.add('is-removing'); });
          setTimeout(() => { row.remove(); if (cart.item_count === 0) showEmpty(); }, 400);
        }
        toast('"' + name + '" removed');
      }
      return cart;
    } catch {
      toast('Could not update cart', true);
    }
  }

  /* ── Empty state ── */
  function showEmpty() {
    const grid = document.querySelector('.cart-grid');
    if (!grid) return;
    grid.innerHTML = `
      <div class="cart-empty">
        <svg class="cart-empty__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
        </svg>
        <h2 class="cart-empty__title">Your cart is empty</h2>
        <p class="cart-empty__text">Add some items to get started.</p>
        <a href="/collections/all" class="cart-empty__cta">Shop Now</a>
      </div>`;
  }

  /* ── Qty controls ── */
  function changeQty(btn, delta) {
    const row = btn.closest('[data-key]');
    if (!row) return;
    const key = row.dataset.key;
    const inp = row.querySelector('.qty-ctrl__val');
    let q = parseInt(inp.value, 10) + delta;
    if (q < 0) q = 0;
    inp.value = Math.max(q, 0);
    const minusBtn = row.querySelector('[data-minus]');
    if (minusBtn) minusBtn.disabled = q <= 1;
    clearTimeout(_debTimer);
    _debTimer = setTimeout(() => updateQty(key, q), CONFIG.debounce);
  }

  function inputQty(inp) {
    const row = inp.closest('[data-key]');
    if (!row) return;
    const key = row.dataset.key;
    let q = parseInt(inp.value, 10);
    if (isNaN(q) || q < 0) { inp.value = 1; q = 1; }
    clearTimeout(_debTimer);
    _debTimer = setTimeout(() => updateQty(key, q), CONFIG.debounce);
  }

  /* ── Discount code ── */
/* ── Discount code ── */
async function applyDiscount(btn) {
  const wrap = btn.closest('.cart-discount-card');
  const inp  = wrap?.querySelector('.cart-discount__input');
  const msg  = document.querySelector('.cart-discount__msg');
  const code = inp?.value?.trim();

  if (!code) {
    if (msg) {
      msg.textContent = 'Please enter a code.';
      msg.className = 'cart-discount__msg err';
    }
    return;
  }

  btn.disabled = true;
  btn.textContent = 'Applying...';

  try {
    /* Step 1: Discount set karo */
    const r = await fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    });

    /* Step 2: Fresh cart fetch karo with discount applied */
    const cartRes = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (!cartRes.ok) throw new Error('Cart fetch failed');
    const cart = await cartRes.json();

    /* Step 3: DOM update */
    applyCart(cart);

    if (msg) {
      msg.textContent = '✓ Discount applied!';
      msg.className = 'cart-discount__msg ok';
    }
    if (inp) inp.value = '';

  } catch (err) {
    if (msg) {
      msg.textContent = '❌ Invalid code or expired.';
      msg.className = 'cart-discount__msg err';
    }
    toast('Discount code not valid', true);

  } finally {
    btn.disabled = false;
    btn.textContent = 'Apply';
  }
}
  /* ── Cart note sync ── */
  async function syncNote(text) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: text }),
      });
    } catch (_) {}
  }

  /* ── Checkout loading + pack discount code ── */
  function checkoutClick(btn) {
    btn.classList.add('loading');

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        let discountCode = '';

        cart.items.forEach(item => {
          const pct = parseInt((item.properties || {})['_discount_pct'] || 0, 10);
          if (pct >= 10) discountCode = 'CHARISMA3';
          else if (pct >= 5 && discountCode !== 'CHARISMA3') discountCode = 'CHARISMA2';
        });

        const url = discountCode ? '/checkout?discount=' + discountCode : '/checkout';
        window.location.href = url;
      })
      .catch(() => {
        window.location.href = '/checkout';
      });
  }

  /* ── Init qty button states ── */
  function initQtyStates() {
    document.querySelectorAll('.qty-ctrl__val').forEach(inp => {
      const row = inp.closest('[data-key]');
      const btn = row?.querySelector('[data-minus]');
      if (btn) btn.disabled = parseInt(inp.value, 10) <= 1;
    });
  }

  /* ── Events (delegated) ── */
  function bind() {
    const root = document.querySelector('.cart-wrap');
    if (!root) return;

    root.addEventListener('click', e => {
      if (e.target.closest('[data-minus]'))           return changeQty(e.target.closest('[data-minus]'), -1);
      if (e.target.closest('[data-plus]'))            return changeQty(e.target.closest('[data-plus]'), 1);
      if (e.target.closest('[data-remove]'))          return updateQty(e.target.closest('[data-remove]').dataset.remove, 0);
      if (e.target.closest('[data-discount-apply]'))  return applyDiscount(e.target.closest('[data-discount-apply]'));
      if (e.target.closest('[data-checkout]'))        return checkoutClick(e.target.closest('[data-checkout]'));
    });

    root.addEventListener('change', e => {
      if (e.target.classList.contains('qty-ctrl__val')) inputQty(e.target);
    });

    const noteEl = root.querySelector('.cart-note-textarea');
    if (noteEl) {
      let nt;
      noteEl.addEventListener('input', () => { clearTimeout(nt); nt = setTimeout(() => syncNote(noteEl.value), 900); });
    }
  }

  /* ── Init ── */
  function init() {
    bind();
    initQtyStates();
    applyDiscountOnLoad(); // ✅ page load pe discount display karo
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();